import {  zipStatic  } from '../operators/zip';

export const zip = zipStatic;



// WEBPACK FOOTER //
// ../../src/observable/zip.ts